const state = {
  progress: {
    fetchUsers: 100,
    creatingRepairHistoryItems: 0,
    uploadHistoryItems: 100,
    calculatingHistoryItems: 5,
    validatingHistory: 5,
    loadDetails: 0,
    undoHistory: 0,
    recalculate: 0,
  },
}

export { state }
